import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AppConfig } from '../app.config';
import { HelpersService } from './helpers.service';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  registerBikeshop(data) {
    return this.http
      .post(
        this.env.url + '/Wizard/Bikeshop/Registration?code=' + this.env.key,
        data,
        {},
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  verifyAccount(verificationCode) {
    return this.http
      .get(
        this.env.url +
          `/Wizard/Bikeshop/Verification/${verificationCode}?code=${this.env.key}`,
        {},
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  setPassword(verificationCode, data) {
    return this.http
      .put(
        this.env.url +
          `/Wizard/Bikeshop/SetPassword/${verificationCode}?code=${this.env.key}`,
        data,
        {},
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  updateBikeShop(verificationCode, data) {
    return this.http
      .put(
        this.env.url +
          `/Wizard/Bikeshop/Update/${verificationCode}?code=${this.env.key}`,
        data,
        {},
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  generateDummyData(verificationCode, data) {
    return this.http
      .post(
        this.env.url +
          `/Wizard/Bikeshop/GenerateData/${verificationCode}?code=${this.env.key}`,
        data,
        {},
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }
}
